"use client"

import { useEffect, useState, useRef, useCallback } from "react"
import { SVG_CHEVRON_DOWN, SVG_CHEVRON_UP } from "../../../Assets/SVG/svg_util"

const DropDown = ({
  label = "",
  name,
  value,
  options,
  placeholder,
  style,
  onValueChange,
  disabled = false,
  setter,
  baggage = false,
  searchAble = true,
}) => {



  const [selectedValue, setSelectedValue] = useState(value == null || value == undefined || value == "" ? "" : value)
  const [showDropdown, setShowDropdown] = useState(false)
  const [error, setError] = useState("")
  const [focusedIndex, setFocusedIndex] = useState(-1)
  const [searchTerm, setSearchTerm] = useState("")
  const [lastKeyPressTime, setLastKeyPressTime] = useState(0)
  const dropdownRef = useRef(null)
  const optionsRef = useRef(null)


  const handleClickOutSide = useCallback((e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setShowDropdown(false)
    }
  }, [])

  useEffect(() => {
    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutSide)
    } else {
      document.removeEventListener("mousedown", handleClickOutSide)
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutSide)
    }
  }, [showDropdown, handleClickOutSide])

  const handleSelect = (option) => {
    if (disabled || option["option-disabled"]) return
    const newValue = baggage ? option : option.value

    setter && setter(newValue)
    setSelectedValue(newValue)
    setShowDropdown(false)
    setError("")
    onValueChange && onValueChange(newValue)
  }

  const handleClick = () => {
    if (!disabled) setShowDropdown(!showDropdown)
  }

  const handleBlur = () => {
    if (selectedValue?.length === 0) {
      // setError("Selection is required");
    } else {
      setError("")
    }
  }

  useEffect(() => {
    if (value !== selectedValue) {
      setSelectedValue(value == null || value == undefined || value == "" ? "" : value)
    }
  }, [value, selectedValue])

  const getDisplayValue = (selectedValue) => {

    if (baggage && typeof selectedValue === "object" && selectedValue !== null) {
      return selectedValue.name || ""
    }
    const selectedOption = options?.find((op) => op.value === selectedValue)
    return selectedOption ? selectedOption.name : ""
  }

  const handleKeyDown = (e) => {
    if (!showDropdown) {
      setShowDropdown(true)
      return
    }
    if (!searchAble) {
      return
    }
    const currentTime = new Date().getTime()
    const timeSinceLastKeyPress = currentTime - lastKeyPressTime

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault()
        setFocusedIndex((prevIndex) => (prevIndex < options?.length - 1 ? prevIndex + 1 : prevIndex))
        break
      case "ArrowUp":
        e.preventDefault()
        setFocusedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : 0))
        break
      case "Enter":
        e.preventDefault()
        if (focusedIndex >= 0 && focusedIndex < options?.length && !options[focusedIndex]["option-disabled"]) {
          handleSelect(options[focusedIndex])
        }
        break
      case "Escape":
        setShowDropdown(false)
        break
      default:
        if (e.key?.length === 1) {
          if (timeSinceLastKeyPress > 500) {
            setSearchTerm(e.key?.toLowerCase())
          } else {
            setSearchTerm((prevTerm) => prevTerm + e.key?.toLowerCase())
          }
          const matchingIndices = options
            ?.map((option, index) => ({
              index,
              name: option?.name?.toLowerCase(),
            }))
            .filter((item) => item.name.startsWith(searchTerm + e.key?.toLowerCase()))
            ?.map((item) => item.index)

          if (matchingIndices?.length > 0) {
            const currentIndex = matchingIndices.indexOf(focusedIndex)
            const nextIndex =
              currentIndex === -1 || currentIndex === matchingIndices?.length - 1
                ? matchingIndices[0]
                : matchingIndices[currentIndex + 1]
            setFocusedIndex(nextIndex)
          }
        }
    }

    setLastKeyPressTime(currentTime)
  }

  useEffect(() => {
    if (focusedIndex !== -1 && optionsRef.current) {
      const focusedElement = optionsRef.current.children[focusedIndex]
      focusedElement?.scrollIntoView({ block: "nearest" })
    }
  }, [focusedIndex])

  useEffect(() => {
    if (showDropdown && selectedValue) {
      if (typeof selectedValue === "object" && Object.keys(selectedValue)?.length > 0) {
        const focusedIndex = options.findIndex((option) => option.value === selectedValue.value)
        setFocusedIndex(focusedIndex)
      } else {
        const focusedIndex = options.findIndex((option) => option.value === selectedValue)
        setFocusedIndex(focusedIndex)
      }
    } else {
      setFocusedIndex(-1)
    }
  }, [showDropdown, selectedValue, options])

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchTerm("")
    }, 1000)

    return () => clearTimeout(timer)
  }, [])


  return (
    <div className="">
      {label?.length > 0 && (
        <div className="py-1 ">
          <label className="text-label">{label}</label>
        </div>
      )}
      <div className="relative flex items-center w-full mx-auto" ref={dropdownRef}>
        <div
          className={`truncate min-h-[40px] w-full py-2 !px-2 !pr-6 rounded-md outline-none border-2 ${
            showDropdown ? "border-[#7ddbff]" : ""
          } bg-[#7ddbff] !bg-opacity-[30%] text-sm cursor-pointer
             ${disabled ? "!bg-gray-300 !text-gray-500 !cursor-not-allowed" : ""}`}
          style={{ ...style }}
          onClick={handleClick}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          tabIndex={0}
          role="combobox"
          aria-expanded={showDropdown}
          aria-haspopup="listbox"
          aria-controls="dropdown-list"
        >
          {value ? getDisplayValue(selectedValue) : placeholder}
        </div>
        {showDropdown && !disabled && (
          <div
            id="dropdown-list"
            ref={optionsRef}
            className="z-10 absolute top-[calc(100%)] left-0 w-full bg-gray-500 border
           border-gray-200 rounded-md mt-1 max-h-[50vh] text-white overflow-auto"
            style={{ width: style?.width }}
            role="listbox"
          >
            {options?.map((option, index) => (
              <div
                key={index}
                className={`p-2 cursor-pointer flex text-start items-center transition-colors duration-200 ease-in-out
                  ${option["option-disabled"] ? "opacity-50 line-through" : "hover:bg-blue-600"}
                  ${focusedIndex === index ? "bg-blue-500" : ""}`}
                onClick={
                  !option["option-disabled"]
                    ? () => handleSelect(option)
                    : (e) => {
                        e.preventDefault()
                        e.stopPropagation()
                      }
                }
                role="option"
                aria-selected={index === focusedIndex}
                aria-disabled={option["option-disabled"]}
              >
                {option.name}
              </div>
            ))}
          </div>
        )}
        <span
          className="absolute right-3 transition-transform duration-700 cursor-pointer"
          style={{ color: style?.color || "black" }}
          onClick={handleClick}
        >
          {showDropdown ? <SVG_CHEVRON_UP /> : <SVG_CHEVRON_DOWN />}
        </span>
        {error && <div className="text-red-500 text-sm mt-1">{error}</div>}
      </div>
    </div>
  )
}

export default DropDown

